import React from 'react';
import {Size} from '../types';
import styled from 'styled-components';
import {COLORS, ComponentLStyling, ComponentMStyling, ComponentSStyling, ComponentTextStyle} from '../styles';

export const Bar = styled.div`
  flex: 1;
  position: relative;
  height: 6px;

  &.last:after {
    content:'';
    display: block;
    position: absolute;
    right: 0px;
    border-radius: 50%;
    background-color: ${props => COLORS.generateToken({ componentType: 'bg-fill', defaultVariant: 'default' }, props.theme)};
  }

  &.small {
    height: 6px;
    &.last:after {
      height: 6px;
      width: 6px;
    }
  }

  &.medium {
    height: 8px;
    &.last:after {
      height: 8px;
      width: 8px;
    }
  }

  &.large {
    height: 12px;
    &.last:after {
      height: 12px;
      width: 12px;
    }
  }

  background-color: ${props => COLORS.generateToken({componentType: 'bg-surface', defaultVariant: 'neutral'}, props.theme)};

  &.active {
    background-color: ${props => COLORS.generateToken({ componentType: 'bg-fill', defaultVariant: 'accent1' }, props.theme)};
  }

  &.current {
    background-color: ${props => COLORS.generateToken({ componentType: 'bg-fill', defaultVariant: 'primary', state: 'active' }, props.theme)};
  }

  &.inverted {
    background-color: ${props => COLORS.getColor('neutral_600', props.theme)};
  }

  &.inverted.active {
    background-color: ${props => COLORS.getColor('accent1_400', props.theme)};
  }

  &.inverted.current {
    background-color: ${props => COLORS.getColor('white', props.theme)};
  }

`;

export const Dot = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;


  &:after {
    content: '';
    display: block;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background-color: ${props => COLORS.generateToken({ componentType: 'bg-surface', defaultVariant: 'neutral' }, props.theme)};
  }

  &.small {
    &:after {
      width: 6px;
      height: 6px;
    }

    
    &.last:after {
      width: 3px;
      height: 3px;
      background-color: ${props => COLORS.generateToken({ componentType: 'bg-fill', defaultVariant: 'default' }, props.theme)};
      box-shadow: 0px 0px 0px 1.5px ${props => COLORS.generateToken({ componentType: 'bg-surface', defaultVariant: 'neutral' }, props.theme)};
    }


    &.current:after {
      width: 10px;
      height: 10px;
    }
  }

  &.medium {
    &:after {
      width: 8px;
      height: 8px;
    }

    &.last:after {
      width: 4px;
      height: 4px;
      background-color: ${props => COLORS.generateToken({ componentType: 'bg-fill', defaultVariant: 'default' }, props.theme)};
      box-shadow: 0px 0px 0px 2px ${props => COLORS.generateToken({ componentType: 'bg-surface', defaultVariant: 'neutral' }, props.theme)};
    }


    &.current:after {
      width: 12px;
      height: 12px;
    }
  }

  &.large {
    &:after {
      width: 12px;
      height: 12px;
    }

    &.last:after {
      width: 6px;
      height: 6px;
      background-color: ${props => COLORS.generateToken({ componentType: 'bg-fill', defaultVariant: 'default' }, props.theme)};
      box-shadow: 0px 0px 0px 3px ${props => COLORS.generateToken({ componentType: 'bg-surface', defaultVariant: 'neutral' }, props.theme)};
    }

    &.current:after {
      width: 16px;
      height: 16px;
    }
  }


  &.active:after {
    background-color: ${props => COLORS.generateToken({ componentType: 'bg-fill', defaultVariant: 'accent1' }, props.theme)};
  }

  &.current:after {
    background-color: ${props => COLORS.generateToken({ componentType: 'bg-fill', defaultVariant: 'primary', state: 'active' }, props.theme)};
  }

  &.inverted:after {
    background-color: ${props => COLORS.getColor('neutral_400', props.theme)};
  }

  &.inverted.active:after {
    background-color: ${props => COLORS.getColor('accent1_400', props.theme)};
  }

  &.inverted.current:after {
    background-color: ${props => COLORS.getColor('white', props.theme)};
  }
`;

export const LineFill = styled.div`
  height: 100%;
  max-width: 100%;
  position: absolute;
  z-index: 1;
`;

export const Line = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  position: relative;

  &:after {
    content: '';
    display: block;
    height: 100%;
    position: absolute;
    right: 0;
  }

  &:before {
    content: '';
    display: block;
    height: 100%;
    position: absolute;
    left: 0;
  }



  &.small {
    height: 6px;
    border-radius: 4px;

    ${LineFill} {
      border-radius: 4px;
    }

    &:after {
      width: 4px;
      height: 4px;
      border-radius: 50%;
      margin-right: 1px;
      background-color: ${props => COLORS.generateToken({ componentType: 'bg-fill', defaultVariant: 'default' }, props.theme)};
    }

    &:before {
      width: 4px;
      height: 4px;
      border-radius: 50%;
      margin-left: 1px;
      background-color: ${props => COLORS.generateToken({ componentType: 'bg-fill', defaultVariant: 'default' }, props.theme)};
    }
  }

  &.medium {
    height: 8px;
    border-radius: 4px;

    ${LineFill} {
      border-radius: 4px;
    }

    &:after {
      width: 4px;
      height: 4px;
      border-radius: 50%;
      margin-right: 2px;
      background-color: ${props => COLORS.generateToken({ componentType: 'bg-fill', defaultVariant: 'default' }, props.theme)};
    }

    &:before {
      width: 4px;
      height: 4px;
      border-radius: 50%;
      margin-left: 2px;
      background-color: ${props => COLORS.generateToken({ componentType: 'bg-fill', defaultVariant: 'default' }, props.theme)};
    }
  }

  &.large {
    height: 12px;
    border-radius: 6px;

    ${LineFill} {
      border-radius: 6px;
    }

    &:after {
      width: 8px;
      height: 8px;
      border-radius: 50%;
      margin-right: 2px;
      background-color: ${props => COLORS.generateToken({ componentType: 'bg-fill', defaultVariant: 'default' }, props.theme)};
    }

    &:before {
      width: 8px;
      height: 8px;
      border-radius: 50%;
      margin-left: 2px;
      background-color: ${props => COLORS.generateToken({ componentType: 'bg-fill', defaultVariant: 'default' }, props.theme)};
    }
  }

  background-color: ${props => COLORS.generateToken({ componentType: 'bg-surface', defaultVariant: 'neutral' }, props.theme)};

  ${LineFill} {
    background-color: ${props => COLORS.generateToken({ componentType: 'bg-fill', defaultVariant: 'default' }, props.theme)};
  }

  &.inverted {
    background-color: ${props => COLORS.getColor('neutral_700', props.theme)};

    &:after,
    &:before {
      background-color: ${props => COLORS.getColor('neutral_400', props.theme)};
    }

    ${LineFill} {
      background-color: ${props => COLORS.getColor('accent1_400', props.theme)};
    }
  }
`;

const Label = styled.div`
  color: ${props => COLORS.generateToken({ componentType: 'text', defaultVariant: 'default' }, props.theme)};
`;

const Content = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  height: 16px;
`;

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;

  &.inverted {
    ${Label} {
      color: ${props => COLORS.getColor('white', props.theme)};
    }
  }

  &.small {
    gap: 4px;

    ${Label} {
      ${ComponentSStyling(ComponentTextStyle.Regular, null)}
    }

    ${Content} {
      gap: 4px;

      ${Bar} {
        border-radius: 6px;
      }
    }
  }

  &.medium {
    ${Label} {
      ${ComponentMStyling(ComponentTextStyle.Regular, null)}
    }

    ${Content} {
      gap: 6px;

      ${Bar} {
        border-radius: 8px;
      }
    }
  }

  &.large {
    ${Label} {
      ${ComponentLStyling(ComponentTextStyle.Regular, null)}
    }

    ${Content} {
      gap: 8px;

      ${Bar} {
        border-radius: 12px;
      }
    }
  }

  &.dots.small,
  &.dots.medium {
    ${Content} {
      padding: 0 2px;
    }
  }

  &.dots.large {
    ${Content} {
      padding: 0 3px;
    }
  }
`;

export enum LinearProgressType {
  Dots = 'dots',
  Line = 'line',
  Bars = 'bars',
}

export enum LinearProgressVariant {
  Normal = 'normal',
  Inverted = 'inverted',
}

export interface LinearProgressProps extends React.HTMLAttributes<HTMLDivElement> {
  /** Size of the component. Defaults to 'medium' */
  size?: Size.Small | Size.Medium | Size.Large;
  /** Progress type. Defaults to 'line' */
  type?: LinearProgressType;
  /** Progress variant. Defaults to 'normal' */
  variant?: LinearProgressVariant;
  /** Label of the component */
  label?: string;
 /** Current value on the progress. */
  value: number;
  /** Maximum value of the progress bar. */
  max: number;
}

const LinearProgress: React.FunctionComponent<LinearProgressProps> = ({
                                                                        size = Size.Medium,
                                                                        type = LinearProgressType.Line,
                                                                        variant = LinearProgressVariant.Normal,
                                                                        label,
                                                                        value,
                                                                        max,
                                                                        className,
                                                                        ...rest
                                                                      }) => {

  const renderBars = () =>
    <>
      {Array.from(Array(max).keys()).map(i => (
        <Bar key={i}
             className={`${Math.ceil(value) >= i + 1 ? 'active' : ''} ${Math.ceil(value) === i + 1 ? 'current' : ''} ${i == max - 1 ? 'last':''} ${variant} ${size}`}/>
      ))}
    </>

  const renderDots = () =>
    <>
      {Array.from(Array(max).keys()).map(i => (
        <Dot key={i}
             className={`${Math.ceil(value) >= i + 1 ? 'active' : ''} ${Math.ceil(value) === i + 1 ? 'current' : ''} ${i == max - 1 ? 'last':''} ${variant} ${size}`}/>
      ))}
    </>

  const renderLine = () =>
    <>
      <Line className={`${variant} ${size}`}>
        <LineFill style={{width: `${value / max * 100}%`}}/>
      </Line>
    </>


  const render = () => {
    switch (type) {
      case LinearProgressType.Bars:
        return renderBars();
      case LinearProgressType.Dots:
        return renderDots();
      case LinearProgressType.Line:
      default:
        return renderLine();
    }
  }

  return (
    <Wrapper className={`${size} ${type} ${variant} ${className || ''}`} {...rest}>
      {label && <Label>{label}</Label>}
      <Content>
        {render()}
      </Content>
    </Wrapper>
  )
};

export default LinearProgress;
